async function updateArticleSpacing($article) {

    const $excerpt = $article.querySelector('.agend-newspaper-grid-article__excerpt');

    if (!$excerpt) {
        return;
    }

    // If the excerpt is not visible or takes no space, bail.
    if ($excerpt.offsetHeight === 0) {
        return;
    }

    // If the excerpt's previously stored updated height is the same, bail.
    if (parseInt($excerpt.dataset.excerptHeight) === $excerpt.offsetHeight) {
        return;
    }

    // Remove any overriding "--line-clamp" properties.
    $excerpt.style.removeProperty('--line-clamp');

    // Wait just a moment so the browser can refresh metrics before we recalc and updated (resizes might result in
    // growing elements as screens are rotated or resized).
    await new Promise(resolve => setTimeout(resolve, 100));

    const excerptLineHeight = parseInt(window.getComputedStyle($excerpt).lineHeight, 10);

    // Work out the space between the bottom of the excerpt and the bottom of the article
    const space = $article.offsetHeight - $excerpt.offsetHeight - $excerpt.offsetTop;

    // Not enough space for extra lines.
    if (space <= excerptLineHeight) {
        return;
    }

    // Get the "--line-clamp" variable from the container.
    const currentLineClamp = parseInt(window.getComputedStyle($excerpt).getPropertyValue('--line-clamp'), 10);
    const newLineClamp = currentLineClamp + Math.floor(space / excerptLineHeight);

    $excerpt.style.setProperty('--line-clamp', newLineClamp.toString());

    // Store the excerpt's new height so we can compare and bail later if the height has not changed.
    $excerpt.dataset.excerptHeight = $excerpt.offsetHeight.toString();
}

document.addEventListener('DOMContentLoaded', event => {

    const $gridArticles = document.querySelectorAll('.agend-newspaper-grid-article');

    if (!$gridArticles.length) {
        return;
    }

    const updateArticles = () => $gridArticles.forEach(updateArticleSpacing);

    // Update spacing initially.
    updateArticles();

    // ...and also on window resize, with a debounce.
    window.addEventListener('resize', () => {
        if (updateArticles._timeout) {
            clearTimeout(updateArticles._timeout);
        }

        updateArticles._timeout = setTimeout(updateArticles, 100);
    });


});
